"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stakingChartSearchValuesCreator = void 0;
const date_fns_1 = require("date-fns");
const types_1 = require("@framework/types");
const types_collection_1 = require("@dzambalaorg/types-collection");
const types_2 = require("../../../../../types");
const baseEmptyValues = {
    contractId: types_collection_1.InputType.awaited,
    deposit: {
        tokenType: types_1.TokenType.ERC20,
        contractId: types_collection_1.InputType.awaited,
    },
    reward: {
        tokenType: types_1.TokenType.ERC721,
        contractId: types_collection_1.InputType.awaited,
    },
    emptyReward: false,
    startTimestamp: (0, date_fns_1.startOfMonth)((0, date_fns_1.subMonths)(new Date(), 1)).toISOString(),
    endTimestamp: (0, date_fns_1.endOfMonth)((0, date_fns_1.addMonths)(new Date(), 1)).toISOString(),
};
const stakingChartSearchValuesCreator = profile => ({
    [types_2.ServiceType.ADMIN]: {
        ...baseEmptyValues,
    },
    [types_2.ServiceType.OFFICE]: {
        ...baseEmptyValues,
        merchantId: profile.merchantId,
    },
});
exports.stakingChartSearchValuesCreator = stakingChartSearchValuesCreator;
//# sourceMappingURL=schemas.js.map